/**
*
* EditModal
*
*/

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'react-bootstrap';
import AlertList from 'components/AlertList/index.jsx';
import PendingForm from 'components/interaction/PendingForm/index.jsx';
import { focusFirstInput } from 'utils/formHelpers.js';
import getSchema from './form.jsx';
import useEditModal from './useEditModal.js';
import messages from '../../messages.js';
import useDefaultRecipientsTab from '../../useDefaultRecipientsTab.js';
import useRecipientRoles from '../../useRecipientRoles.js';

const Wrapper = styled(Modal)`
  @media (min-width: 768px) {
    .modal-dialog {
      width: 720px;
    }
  }
`;

function EditModal(props) {
  const { post, show, onHide } = props;
  const { defaultValues, handleSubmit, handleDelete, handleChange, handleHide, inboxId } = useEditModal(post, onHide);
  const [values, setValues] = useState(defaultValues);
  const [selectingDate, setSelectingDate] = useState(false);
  const [defaultRole, setDefaultRole] = useDefaultRecipientsTab();
  const roles = useRecipientRoles();

  useEffect(() => setValues(defaultValues), [post?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  function handleSelectOpen(val) {
    const elem = document.getElementById('conversations-edit-modal');
    elem.parentElement.style.display = val ? 'none' : 'block';
    if (!val) {
      focusFirstInput('#conversations-participants + div');
    }
  }

  function handleChange2(newValues) {
    setValues(newValues);
    handleChange(newValues);
  }

  function handleCancelParticipants(submitted) {
    if (!submitted) {
      handleHide();
    }
  }

  const focusInput = post?.id ? 'title' : undefined;
  const schemaOptions = {
    onPopup: handleSelectOpen,
    onCancel: handleCancelParticipants,
    typeDisabled: Boolean(post?.id),
    defaultRole,
    setDefaultRole,
    inboxId,
    roles,
  };

  const schema = getSchema(values, schemaOptions);

  const className = selectingDate ? 'opacity-0' : '';

  return (
    <Wrapper id="conversations-edit-modal" className={className} backdrop="static" enforceFocus={false} keyboard={false} show={show} onHide={handleHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage {...messages.addMessage} />
        </Modal.Title>
      </Modal.Header>
      <PendingForm
        defaultValues={defaultValues}
        schema={schema}
        onCancel={handleHide}
        onChange={handleChange2}
        onSubmit={handleSubmit}
        onDelete={handleDelete}
        focusInput={focusInput}
        onSelectingDate={setSelectingDate}
        navigationWarning
      >
        {({ body, action }) => (
          <>
            <Modal.Body>
              <AlertList />
              {body}
            </Modal.Body>
            <Modal.Footer>
              {action}
            </Modal.Footer>
          </>
        )}
      </PendingForm>
    </Wrapper>
  );
}

EditModal.propTypes = {
  post: PropTypes.object,
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
};

export default EditModal;
